<div class="row nova-font-style bottom-margin-0">
    <!-- LEFT CONTAINER -->
    <div class="col s12 m12 l4 xl3">
      <div class="left-container">
        <div id="history-container" filterIcons [filterRows]="filterRows" [pageIn]="'Adjustments'">
          <h2>History</h2>
          <kendo-grid id="adjustment-history-grid" [kendoGridBinding]="gridView" [scrollable]="'auto'" [resizable]="true"
            [sortable]="true" [pageable]="true" [filterable]="true" [pageSize]="gridState.take" [skip]="gridState.skip"
            [sort]="gridState.sort" [selectable]="selectableSettings" (add)="addHandler()"
            (pageChange)="pageChange($event)" (cellClick)="cellClickHandler($event)">

              <ng-template kendoGridToolbarTemplate *ngIf="!disableAddAdj && operators.Add">
                <div class="row bottom-margin-0">
                  <div class="col s12 m12 l12 xl12 margin-5 left-padding-0">
                    <button kendoGridAddCommand class="btn btn-fullwidth background-red right-margin-5"
                      id="create-new-adjustments"><span class='k-icon k-i-plus-circle height-auto'></span>Add
                      Adjustment</button>
                  </div>
                </div>
              </ng-template>

            <!-- Mobile View -->
            <kendo-grid-column media="(max-width: 992.98px)" title="Details">
              <ng-template kendoGridCellTemplate let-dataItem>
                <!-- template for mobile -->
                <dl>
                  <!-- Adjustment Id -->
                  <dd>
                    <div class="align-left">
                      <span class="bold">Adjustment Id: </span>
                      {{ dataItem.id }}
                    </div>
                  </dd>
                  <!-- Created Date -->
                  <dd>
                    <div class="align-left">
                      <span class="bold">Created: </span>
                      {{ dataItem.submittedDate }}
                    </div>
                  </dd>
                  <!-- Status -->
                  <dd>
                    <div class="align-left">
                      <span class="bold">Status: </span>
                      {{ dataItem.statusMessage }}
                    </div>
                  </dd>
                </dl>
              </ng-template>
            </kendo-grid-column>

            <!-- ID COLUMN -->
            <kendo-grid-column field="id" media="(min-width: 993px)" title="Id" [width]="50">
              <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                <kendo-grid-string-filter-cell [column]="column" [showOperators]="false" [filter]="filter"
                  [spinners]="false"></kendo-grid-string-filter-cell>
              </ng-template>
            </kendo-grid-column>

            <!-- CREATED COLUMN-->
            <kendo-grid-column field="submittedDate" media="(min-width: 993px)" title="Created" [width]="85"
              [headerClass]="{'align-date': true}">
              <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                <kendo-grid-string-filter-cell [column]="column" [showOperators]="false" [filter]="filter"
                  [spinners]="false">
                </kendo-grid-string-filter-cell>
              </ng-template>
              <ng-template kendoGridCellTemplate let-dataItem>
                <div class="align-date">
                  <span>
                    {{dataItem.submittedDate}}
                  </span>
                </div>
              </ng-template>
            </kendo-grid-column>

            <!-- STATUS COLUMN -->
            <kendo-grid-column field="statusMessage" media="(min-width: 993px)" title="Status" [width]="90"
              [headerClass]="{'align-center': true}">
              <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                <kendo-grid-string-filter-cell [column]="column" [showOperators]="false" [filter]="filter"
                  [spinners]="false"></kendo-grid-string-filter-cell>
              </ng-template>
              <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                <div class="align-center status-approve" *ngIf="dataItem.isApproved; else appr">
                  <span>{{dataItem.statusMessage}}</span>
                </div>
                <ng-template #appr>
                  <div class="align-center status-reject" *ngIf="dataItem.actionBy; else pending">
                    <span>{{dataItem.statusMessage}}</span>
                  </div>
                  <ng-template #pending>
                    <div class="align-center status-pending">
                      <span>{{dataItem.statusMessage}}</span>
                    </div>
                  </ng-template>
                </ng-template>
              </ng-template>
            </kendo-grid-column>

            <!-- DELETE COLUMN -->
            <kendo-grid-column title="" media="(min-width: 993px)" [headerClass]="{'align-center': true}"
              *ngIf="operators.Delete" [width]="45">
              <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                <div class="align-center" kendoTooltip>
                  <a (click)="deleteAdjDialog(dataItem.id)" *ngIf="!dataItem.isDeletable && !dataItem.isApproved">
                    <span class="k-icon k-i-delete link-icon" title="Delete"></span>
                  </a>
                </div>
              </ng-template>
            </kendo-grid-column>

            <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
              <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
              <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
              <kendo-pager-next-buttons></kendo-pager-next-buttons>
              <kendo-pager-info></kendo-pager-info>
            </ng-template>
          </kendo-grid>
        </div>
        <div *ngIf='adjRecordData?.id !== 0 && this.gridView?.length !== 0 && this.recordSelected'>
          <div class="common-stroke-separator" id="stroke-separator"></div>
          <!-- ADJUSTMENT SUMMARY -->
          <app-adjustment-summary [adjustmentSummaryRecord]="adjSummaryRecords"></app-adjustment-summary>
        </div>
      </div>
    </div>
    <!-- RIGHT CONTAINER -->
    <div class="col s12 m12 l8 xl9" id="adjustments-grid">
      <div class="right-container">
        <div class="col s12 m12 l6 xl6 padding-0 adj-header" *ngIf='adjRecordData?.id === 0; else adjRecords'>
          <h2>Submitting Adjustments</h2>
        </div>
        <ng-template #adjRecords>
          <h2>Submitted Adjustment</h2>
        </ng-template>

        <!-- ADJUSTMENT RECORD -->
        <div class="col xs12 s12 m12 l12 xl12 padding-0">
          <div class="col xs12 s12 m12 l12 xl8 padding-0" *ngIf="gridView && gridView.length !== 0 && adjSummaryRecords && recordSelected && adjSummaryRecords.actionDate">
            <div class="top-margin-10 popup-note" *ngIf="(!adjSummaryRecords.isApproved) else approvedComment">
              <span [innerHTML]="config.RejectAdjustmentMsg"></span>
              <p id="adj-comment" class="margin-0 break-all-word">{{adjSummaryRecords.comments}}</p>
            </div>
            <ng-template #approvedComment>
              <div class="top-margin-10 popup-note">
                <span [innerHTML]="config.ApproveAdjustmentMsg"></span>
                <div *ngIf="adjSummaryRecords.comments">
                  <p class='bold margin-0'>Approved reason</p>
                  <p class="margin-0 break-all-word">{{adjSummaryRecords.comments}}</p>
                </div>
              </div>
            </ng-template>
          </div>
          <div class="col xs12 s12 m12 l12 xl8 padding-0" *ngIf="gridView && gridView.length !== 0 && recordSelected">
            <div class="top-margin-10 popup-note align-center"
              *ngIf="!contributionWithheld && adjSummaryRecords.isDebitInvoice && (adjSummaryRecords.isApproved || adjSummaryRecords.statusMessage === 'Pending')">
              No withheld contribution.
            </div>
            <div class="top-margin-10 popup-note align-center"
              *ngIf="!isCurrentFy && !adjSummaryRecords.isDebitInvoice && (adjSummaryRecords.isApproved || adjSummaryRecords.statusMessage === 'Pending')">
              The adjustment includes previous calendar/tax year(s) contributions.
            </div>
          </div>
          <div *ngIf="(contributionWithheld || (recordSelected && recordSelected.amount)) || (this.gridView?.length !== 0 && this.adjRecordData?.id === 0)">
            <app-adjustment-record #adjustmentRecordsGrid (resetEvent)="resetChanges($event)"
              (cancelEvent)="cellClickHandler({})" (recordSavedResponse)="recordSaved($event)"
              [adjustmentsRecord]="adjRecordData" [isBankInfoAvail]="bankInfoExist"></app-adjustment-record>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-notification-loading></app-notification-loading>

  <kendo-dialog title="Delete Adjustment" class="app-dialog" *ngIf="adjDeleteDialog" [minWidth]="250"
    (close)="deleteAdj('no')" id="delete-adjustment-dialog">
    <p>Do you want to permanently delete this adjustment?</p>
    <div *ngIf="displayload">
      <div class="stroke-separator-margin-5"></div>
      <span class="k-i-loading k-icon col-md-offset-5 dialog-inner-loading"></span>
      <span class="dotLoading">Deleting</span>
    </div>
    <kendo-dialog-actions>
      <button kendoButton class="k-button" [disabled]="displayload" (click)="deleteAdj('no')" primary="true">No</button>
      <button kendoButton class="k-button" [disabled]="displayload" (click)="deleteAdj('yes')" primary="true">Yes</button>
    </kendo-dialog-actions>
  </kendo-dialog>

  <!-- PLEASE CONFIRM DIALOG -->
  <kendo-dialog title="Please confirm" class="app-dialog" *ngIf="confirmOpen" [minWidth]="250"
    (close)="onCancelBtnClick('no')" id="please-confirm-dialog">
    <p>All unsaved changes will be lost. Continue?</p>
    <kendo-dialog-actions>
      <button kendoButton class="k-button" [disabled]="displayload" (click)="onCancelBtnClick('no')" primary="true">No</button>
      <button kendoButton class="k-button" [disabled]="displayload" (click)="onCancelBtnClick('yes')" primary="true">Yes</button>
    </kendo-dialog-actions>
  </kendo-dialog>
